import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { Avatar, Button, Card, Paragraph, useTheme } from 'react-native-paper'
import DietInformation from './DietInformation'
import MealImage from './MealImage'

const getIcon = (recipe) => {
  if (recipe.glutenFree == 'true') {
    return 'barley-off'
  }
  if (recipe.vegan == 'true') {
    return 'egg-off-outline'
  }
  if (recipe.vegetarian == 'true') {
    return 'cow-off'
  }
  if (recipe.title.includes('Burger')) {
    return 'hamburger'
  }
  if (recipe.title.includes('Chicken')) {
    return 'food-drumstick'
  }
  if (recipe.title.includes('Cod', 'Fish', 'Snapper')) {
    return 'fish'
  }
  return 'food-variant'
}

const SwapButton = ({ onPress }) => {
  if (!onPress) return null

  return (
    <Button
      mode="contained"
      style={styles.swapButton}
      icon={'reload'}
      onPress={onPress}
    >
      SWAP
    </Button>
  )
}

const RecipeCard = ({ recipe, onPress, onSwap }) => {
  const { colors } = useTheme()

  if (!recipe) return null

  const LeftContent = (props) => (
    <Avatar.Icon
      {...props}
      icon={getIcon(recipe)}
      color={colors.text}
      borderRadius={6}
    />
  )

  return (
    <Card style={styles.container} onPress={onPress}>
      <MealImage style={styles.mealImage} name={recipe.title} />
      <Card.Title
        title={recipe.title}
        titleNumberOfLines={2}
        subtitle={recipe.cuisines.join(' ')}
        left={LeftContent}
      />
      <Card.Content style={styles.cardContent}>
        <View style={styles.addedInfo}>
          {recipe.preparationMinutes && (
            <Text style={styles.addedInfoText}>
              Prep: {recipe.preparationMinutes}min
            </Text>
          )}
          {recipe.cookingMinutes && (
            <Text style={styles.addedInfoText}>
              Cook: {recipe.cookingMinutes}min
            </Text>
          )}
        </View>
        {/* <Divider theme={{ colors: { primary: '#faa61a' } }} /> */}
        <Paragraph>{recipe.summary.replace(/(<([^>]+)>)/gi, '')}</Paragraph>
      </Card.Content>
      {/* <Divider theme={{ colors: { primary: '#faa61a' } }} /> */}
      <Card.Actions
        style={{ justifyContent: 'flex-start', flex: 1, paddingVertical: 8 }}
      >
        <View style={styles.footerArea}>
          <View style={styles.diet}>
            <DietInformation {...{ recipe, detailed: false }} />
          </View>
          <SwapButton onPress={onSwap} />
        </View>
      </Card.Actions>
    </Card>
  )
}

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    marginVertical: 20,
    flexGrow: 1,
    flex: 1,
    width: '100%',
    padding: 0,
    borderRadius: 15,
  },
  cardContent: {
    paddingVertical: 12,
    flex: 1,
    flexGrow: 1,
  },
  addedInfo: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 10,
    justifyContent: 'space-between',
  },
  addedInfoText: {
    fontWeight: 'bold',
    color: 'white',
  },
  footerArea: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  diet: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  swapButton: {
    padding: 2,
    paddingHorizontal: 12,
    borderRadius: 10,
  },
  mealImage: {
    backgroundColor: '#132936',
  },
})

export default RecipeCard
